import React, { useState } from 'react'
import { Formik, Form } from 'formik';
import { MainInput, SubmitButton } from '../../components';
import { useDispatch } from 'react-redux';
import { setFormSubmitting } from '../../../application/store/actions/ui';
import { useSelector } from 'react-redux';
import { getFormSubmittingState } from '../../../application/store/selectors/ui';
import services from '../../../ioc/services';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../application/utils/Routes';

function AddAdminForm({ isEdit = false, adminData = null }) {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isFormSubmitting = useSelector(getFormSubmittingState)

    const [isSuperAdmin, setIsSuperAdmin] = useState(false)

    return (
        <div className="w-full p-6">
            <Formik
                initialValues={adminData ?? {}}
                onSubmit={async (values) => {

                    dispatch(setFormSubmitting(true))

                    if (!isEdit) {
                        if (isSuperAdmin) {
                            services.api.admin.addSuperAdmin(values)
                                .then(res => {
                                    services.alert.toast.success("Super Admin Created Successfully");
                                    navigate(ROUTES.ADMINS)
                                }).catch(err => {
                                    services.alert.toast.error(err)
                                })
                                .finally(() => {
                                    dispatch(setFormSubmitting(false))
                                })
                        }
                        else {
                            services.api.admin.addAdmin(values)
                                .then(res => {
                                    services.alert.toast.success("Admin Created Successfully");
                                    navigate(ROUTES.ADMINS)
                                }).catch(err => {
                                    services.alert.toast.error(err)
                                })
                                .finally(() => {
                                    dispatch(setFormSubmitting(false))
                                })
                        }
                    }
                    else {
                        
                        if (adminData == null) {
                            services.alert.toast.error("No data to submit");
                            return;
                        }
                        services.api.admin.editAdmin(adminData.id, values)
                            .then(res => {
                                services.alert.toast.success("Admin Updated Successfully");
                                window.location.reload();
                            }).catch(err => {
                                services.alert.toast.error(err)
                            })
                            .finally(() => {
                                dispatch(setFormSubmitting(false))
                            })

                    }

                    dispatch(setFormSubmitting(false))

                    //dispatch(logUserIn(values))
                }}>
                <Form className="grid grid-cols-2 gap-10 w-full ">
                    <MainInput label="First Name" name="firstName" type="text" placeholder=" " />
                    <MainInput label="Last Name" name="lastName" type="text" placeholder=" " />
                    <MainInput label="Email" name="email" type="text" placeholder=" " />
                    <MainInput label="Phone Number" name="phoneNumber" type="text" placeholder=" " />
                    <MainInput label="Location" name="location" type="text" placeholder=" " />
                    {!isEdit && <div className=' col-span-2 justify-center'>
                        <input type="checkbox" className='mr-6' id='super-check' onChange={(e) => {
                            setIsSuperAdmin(e.target.checked)
                        }} />
                        <label className="text-sm font-semibold text-gray-500" htmlFor='super-check'>Add as Super Admin</label>
                    </div>}
                    <div className='col-span-2 flex justify-center'>
                        <SubmitButton text={isEdit ? "Update Admin" : "Add Admin"} classes="w-auto px-32" disabled={isFormSubmitting} />
                    </div>
                </Form>

            </Formik>



        </div>
    )
}

export default AddAdminForm